import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionPluginService, InspectionService, PluginModelService } from '../../shared/services/index';
import { ApplicationSubType, Inspection, InspectionPlugin, InspectionValidator } from '../../shared/models/index';

import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './validation.component.html',
    standalone: false
})
export class InspectionValidationPageComponent extends BaseModalPageComponent implements OnInit {
  inspection: Inspection;
  inspectionId: string;
  returnUrl: string;
  validatedPlugins: Array<{ data: InspectionPlugin; messages: string[] }> = [];
  errorMessage: string;

  constructor(
    public inspectionService: InspectionService,
    private pluginModelService: PluginModelService,
    private pluginService: InspectionPluginService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;
      this.returnUrl = params['returnUrl'];
      this.initData();
    });
  }

  cancel(): void {
    if (this.returnUrl) {
      this.router.navigate([this.returnUrl]);
      return;
    }
    if (this.inspection.applicationSubType === ApplicationSubType.ParentInstallation) {
      this.router.navigate([this.inspectionsRoute, this.inspection.id, 'inspections']);
      return;
    }
    this.router.navigate([this.inspectionsRoute, this.inspection.id]);
  }

  initData(): void {
    this.inspectionService.getInspection(this.inspectionId).subscribe((el) => {
      this.inspection = el;
      this.pluginService.updatePluginsPostUrl(this.inspectionId, this.inspection.plugins);
      this.pluginModelService
        .getPluginModelsValidationSchemas(el.inspectionType.toString(), el.status.toString())
        .subscribe((validationSchemas) => {
          const validator = new InspectionValidator(validationSchemas);
          this.inspection.accept(validator);
          if (validator.hasErrors()) {
            this.errorMessage = 'error';
            this.validatedPlugins = validator.errors;
          }
        });
    });
  }
}
